import { useState } from "react";
import { Button } from "antd";
import "./css/loadprint.css";
import { createPdfRePrintAcc1 } from "./ExportRePrintAcc1";
import { createPdfRePrintAcc3 } from "./ExportRePrintAcc3";
import { createPdfRePrintAcc2And8 } from "./ExportRePrintAcc2And8";
// import { baseUrlNIKKI, HEADERS_BASIC, SEARCH_CONTNO_V2 } from "../../../API/apiUrlsNew";
// import axios from 'axios'

function PrintPDF({ dataTabelB, selectedContract, setPrintingAll, selectedLawyer }) {

  const [batchIndex, setBatchIndex] = useState(0);
  const [printing, setPrinting] = useState(false);
  const batchSize = 200; // ✅ แบ่งชุดละ 300
  const totalBatches = Math.ceil(dataTabelB.length / batchSize);

  const handlePDF = async () => {
    handleExport()
  };

  const triggerPrintWindow = (blobUrl) => {
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.top = "-9999px";
    iframe.style.left = "-9999px";
    iframe.style.width = "1000px";
    iframe.style.height = "1000px";
    iframe.style.border = "0";

    document.body.appendChild(iframe);

    iframe.onload = () => {
      const win = iframe.contentWindow;
      win.focus();
      win.print();

      // ตั้งเวลาลบ iframe ทิ้ง (เผื่อไว้ 5 นาทีค่อยลบ เพื่อไม่ให้ error ตอนปริ้น)
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      }, 300000);
    };

    iframe.src = blobUrl;
  };

  const handleExport = async () => {
    if (!dataTabelB?.length) return;
    if (!selectedLawyer) {
      alert("กรุณาเลือกทนายก่อนพิมพ์");
      return;
    }

    setPrinting(true);
    setPrintingAll(true);

    const batchSize = 200;
    const totalBatches = Math.ceil(dataTabelB.length / batchSize);

    try {
      for (let i = 0; i < totalBatches; i++) {
        setBatchIndex(i + 1)

        // 1. เตรียมข้อมูล
        const batchData = dataTabelB.slice(
          i * batchSize,
          (i + 1) * batchSize
        );

        let blobUrl;
        if (selectedContract?.key === "psfhp" || selectedContract?.key === "rpsl") {
          // สัญญา 3 เก่า ใหม่
          blobUrl = await createPdfRePrintAcc3(
            batchData,
            i + 1,
            selectedLawyer
          );
        } else if (selectedContract?.key === "vsfhp" || selectedContract?.key === "sfhp") {
          // สัญญา 2 8
          blobUrl = await createPdfRePrintAcc2And8(
            batchData,
            i + 1,
            selectedLawyer
          );
        } else if (selectedContract?.key === "lsfhp") {
          // สัญญา 1
          blobUrl = await createPdfRePrintAcc1(
            batchData,
            i + 1,
            selectedLawyer
          );

        }

        // 3. สั่งปริ้น
        triggerPrintWindow(blobUrl);

        // 4. 🔥 แก้ใหม่: ใช้การวนเช็ค (Polling) แทน Event Listener
        if (i < totalBatches - 1) {

          // รอ 1 วินาที ให้หน้าต่าง Print เด้งขึ้นมาให้เรียบร้อยก่อน
          await new Promise(r => setTimeout(r, 1000));

          // วนลูปเช็คทุก 1 วินาที จนกว่า User จะปิดหน้าต่าง Print (Focus กลับมาที่หน้าเว็บ)
          await new Promise((resolve) => {
            const checkInterval = setInterval(() => {
              // document.hasFocus() จะเป็น true ก็ต่อเมื่อหน้าต่าง Print ถูกปิดลงแล้ว
              if (document.hasFocus()) {
                clearInterval(checkInterval); // หยุดเช็ค
                resolve(); // ไปต่อ!
              }
            }, 1000);
          });

          // พักอีกนิดนึง (0.5วิ) เพื่อความชัวร์ว่า Browser เคลียร์ Dialog หมดแล้วจริงๆ
          await new Promise(r => setTimeout(r, 500));

          const msg = `พิมพ์ชุดที่ ${i + 1} เสร็จเรียบร้อย\nกด OK เพื่อพิมพ์ชุดที่ ${i + 2} ต่อ`;
          const userClickedOK = window.confirm(msg);

          // คืน RAM
          URL.revokeObjectURL(blobUrl);

          if (!userClickedOK) {
            break;
          }
        } else {
          // รอบสุดท้าย รอแป๊บเดียวแล้วจบเลย
          await new Promise(r => setTimeout(r, 2000));
          URL.revokeObjectURL(blobUrl);
        }
      }

    } catch (error) {
      console.error("Error:", error);
      alert("เกิดข้อผิดพลาด: " + error.message);
    } finally {
      setPrinting(false);
      setPrintingAll(false);
      // setCurrentBatchNum(0);
    }
  };

  // const loadDB2 = async (value, selectedContract) => {

  //   var payload = {
  //     lsfhp: "",
  //     lsfhp_ksm: "",
  //     psfhp: "",
  //     rpsl: "",
  //     sfhp: "",
  //     tsfhp_ksm: "",
  //     vsfhp: "",
  //     vsfhp_ksm: "",
  //   }

  //   payload[selectedContract] = value;

  //   console.log(payload);

  //   await axios.post(baseUrlNIKKI + SEARCH_CONTNO_V2, payload, { headers: HEADERS_BASIC })
  //     .then(async (res) => {
  //       if (res.status === 200) {
  //         console.log("res", res.data);

  //         setLoading(false);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       if (err.status === 404) {
  //         message.error("ไม่มีเลขที่สัญญาที่ค้นหา");
  //       }
  //     });

  // }

  return (
    <>
      <Button type="primary" onClick={handlePDF} disabled={printing} danger>
        {printing
          ? `กำลังพิมพ์ ${batchIndex}/${totalBatches}`
          : `พิมพ์ PDF (${dataTabelB.length} ใบ)`}
      </Button>
    </>
  );
}
export default PrintPDF;

